import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { AWS_URL } from "../../../configs/constants";
import CustomButton from "../../common/Button/CustomButton";
import { typo } from "../../../assets/fonts/font";
import { useNavigate } from "react-router-dom";
import { ISkuDetail } from "../../../models/ISkuDetail";
import colorConfigs from "../../../configs/colorConfigs";

const SingleProductPage: React.FC<{ product: ISkuDetail }> = ({ product }) => {
  const navigate = useNavigate();

  const handleViewProduct = () => {
    navigate(`/product/${product.slug}`);
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", sm: "290px" },
        paddingY: { xs: 2, sm: 3 },
        display: "flex",
        justifyContent: "center",
        backgroundColor: "var(--color-white)",
        borderRadius: "20px",
        borderWidth: "1px",
        borderColor: "var(--color-black)",
        borderStyle: "solid",
        margin: "auto",
      }}
    >
      <Stack
        direction={"column"}
        spacing={2} 
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            ...typo.title,
            textAlign: "center",
            height: {xs:'60px', sm:'80px'},
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            paddingBottom:2,
            paddingX:2,           
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitBoxOrient: "vertical",
            lineHeight: "1.5rem",
            fontSize:{xs:"14px", sm:"20px"}
          }}
        >
          {product.name}
        </Box>

        <Box
          component="img"
          src={`${AWS_URL}/${product.image_url}`}
          alt={product.name}
          sx={{
            width: '100%',
            maxWidth: '200px',
            height: { xs: '150px', sm: '200px' },
            objectFit: 'contain',
          }}
        />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            width: "100%",
            paddingX: 2,
          }}
        >
          <Box sx={{ ...typo.bodyContent }}>${Number(product.price).toFixed(2)}</Box>

          <CustomButton
            sx={{ width: "100%" }}
            buttonType="primary"
            onClick={handleViewProduct}
          >
            <Typography component="span" sx={{ ...typo.button, color: colorConfigs.collectionProductButtonText }}>
              View Product
            </Typography>
          </CustomButton>
        </Box>
      </Stack>
    </Box>
  );
};

export default SingleProductPage;